import React from "react";
import { Route } from "react-router-dom";
import { Admin, Resource, ListGuesser } from "react-admin";

import AuthProvider from "./Providers/AuthProvider";
import Provider from "./Providers/DataProvider";

import GeneralReducer from "./Reducers/General";

import Layout from "./Layout/Admin/Layout";
import Theme from "./General/Theme";

import Configuration from "./Pages/Configuration/";
import ThemePage from "./Pages/Theme/Theme";
import Products from "./Pages/products/Products";
import Home from "./Pages/Home/Home";
import NotFound from "./Pages/NotFound";
import Statistics from "./Pages/Statistics/Statistics";

import QrcodePage from "./Pages/QrcodePage";

import {
  AccessTime,
  FormatColorFill,
  Category,
  LocationOn,
  Dns,
} from "@material-ui/icons";

import { ThemeList, ThemeCreate, ThemeEdit } from "./Layout/Theme/Theme";

import TranslationProvider from "./Translation/Translation";
import {
  ProductList,
  ProductEdit,
  ProductCreate,
} from "./Layout/Product/Product";
import {
  CategoryList,
  CategoryEdit,
  CategoryCreate,
} from "./Layout/Category/Category";
import {
  AddressList,
  AddressEdit,
  AddressCreate,
} from "./Layout/Address/Address";
import {
  OpeningsList,
  OpeningsEdit,
  OpeningsCreate,
} from "./Layout/Openings/Openings";
import Login from "./Layout/Login/Login";

const customRoutes = [
  <Route exact path="/home" component={Home} />,
  <Route exact path="/statistics" component={Statistics} />,
  <Route exact path="/configuration" component={Configuration} />,
  <Route exact path="/404" component={NotFound} />,
  <Route exact path="/qrcode" component={QrcodePage} />,
  <Route exact path="/themeEdit" component={ThemePage} />,
  <Route exact path="/product" component={Products} />,
];

const App = () => {
  return (
    <Admin
      layout={Layout}
      customRoutes={customRoutes}
      dataProvider={Provider()}
      authProvider={AuthProvider()}
      loginPage={Login}
      theme={Theme}
      customReducers={{ general: GeneralReducer }}
      i18nProvider={TranslationProvider}
      dashboard={Home}
    >
      {/* <Resource
        name="login"
        icon={<FormatColorFill style={{ color: "#fff" }} />}
        list={Login}
      /> */}

      {/* <Resource
        name="theme"
        icon={<FormatColorFill style={{ color: "#fff" }} />}
        list={ThemeList}
        create={ThemeCreate}
        edit={ThemeEdit}
      /> */}

      <Resource name="product" edit={ProductEdit} create={ProductCreate} />

      <Resource
        name="category"
        icon={<Category style={{ color: "#fff" }} />}
        list={CategoryList}
        create={CategoryCreate}
        edit={CategoryEdit}
      />

      <Resource
        name="address"
        icon={<LocationOn style={{ color: "#fff" }} />}
        list={AddressList}
        edit={AddressEdit}
        create={AddressCreate}
      />

      <Resource
        name="opening"
        icon={<AccessTime style={{ color: "#fff" }} />}
        list={OpeningsList}
        edit={OpeningsEdit}
        create={OpeningsCreate}
      />
    </Admin>
  );
};

export default App;
